import React from "react";
import Navbar from "../components/Navbar"; // Navbar bileşeni
import Footer from "../components/Footer"; // Footer bileşeni
import ServicesSection from "../components/ServicesSection";
import AboutSection from "../components/AboutSection";
import ContactSection from "../components/ContactSection";
import heroImage from "../assets/hero-bg.webp"; // Fotoğrafı assets'ten çekiyoruz

const Home = () => {
  return (
    <div>
      <Navbar /> {/* Navbar eklendi */}
      {/* Hero Section */}
      <section
        className="min-h-screen flex items-center justify-center text-center px-6 bg-cover bg-center"
        style={{
          backgroundImage: `url(${heroImage})`,
        }}
      >
        <div className="bg-black bg-opacity-50 p-6 rounded-lg">
          <h1 className="text-4xl sm:text-6xl font-bold text-white">
            Softrein ile Geleceği Yakalayın
          </h1>
          <p className="text-gray-200 text-lg mt-4">
            MES ve OEE projeleri ile üretiminizi dijitalleştirerek verimliliğinizi artırın.
          </p>
          <button className="mt-6 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">
            Hemen Keşfedin
          </button>
        </div>
      </section>
      <AboutSection />
      <ServicesSection />

      {/* Referanslar veya Avantajlar */}
      <section className="bg-gray-100 py-12">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-gray-800 text-center mb-8">
            Neden Softrein?
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              "Yenilikçi Çözümler",
              "Uzman Kadro",
              "Müşteri Odaklılık",
            ].map((advantage, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition"
              >
                <h3 className="text-lg font-semibold text-gray-800 text-center">
                  {advantage}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </section>
      <ContactSection />
      <Footer /> {/* Footer eklendi */}
    </div>
  );
};

export default Home;
